import { WizardCorpora } from "@radarly/models/corpora";
import {
  AccountModal,
  WizardAccount,
} from "@radarly/models/insight-pages/wizard/model/account";
import {
  AccountsConfigurationField,
  WizardConfiguration,
} from "@radarly/models/insight-pages/wizard/model/configuration";

export function useWizardSidebarAccounts(
  type: AccountModal,
  configuration: WizardConfiguration,
  updateConfiguration: (configuration: Partial<WizardConfiguration>) => void
) {
  const conf = configuration.fields[type];
  const updateFieldinConf = (updatedField: AccountsConfigurationField) =>
    updateConfiguration({ fields: { [type]: updatedField } });
  const onDeleteAccount = (account: WizardAccount) => {
    const validAccounts = [...conf.accounts].filter(
      (prevAccount) =>
        prevAccount.screenName !== account.screenName ||
        prevAccount.platform !== account.platform
    );
    return updateFieldinConf({ ...conf, accounts: validAccounts });
  };

  const onDeleteMe = () => updateFieldinConf({ ...conf, me: false });

  const onDeleteCorpus = (corpusId: WizardCorpora["id"]) => {
    updateFieldinConf({
      ...conf,
      corpora: [...conf.corpora].filter((corpus) => corpus.id !== corpusId),
    });
  };

  return {
    me: conf.me,
    accounts: conf.accounts,
    corpora: conf.corpora,
    onDeleteAccount,
    onDeleteMe,
    onDeleteCorpus,
    conf,
    updateFieldinConf,
  };
}
